import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { VerifiyNumberPopupProps } from "../../types/GeneralComponents";
import { combinePhoneNumberWithISO } from "../../utils/Functions";
import Button from "../GeneralComponents/Button";
import ErrorsWrapper from "../GeneralComponents/ErrorsWrapper";
import Modal from "../GeneralComponents/Modal";

const VerifiyNumberPopup: React.FC<VerifiyNumberPopupProps> = ({
  show,
  setShow,
  phoneNumber,
  hideEditButton,
  countryZipCode,
  error,
  editButtonOnClickFunction,
  disableButtonCondition,
  navigateAfterSuccessFunction,
}) => {
  const { t } = useTranslation();

  //?====================Handle Submit Via Pressing Enter =============================
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && show) {
        navigateAfterSuccessFunction();
      }
    };

    if (show) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  return (
    <Modal
      isOpen={show}
      height="h-20vw"
      onClose={() => {
        setShow(false);
        editButtonOnClickFunction();
      }}
      disableCancel={true}
    >
      <p className="pb-6 text-lg font-bold text-headingTextColor">
        {t("verify_your_number")}
      </p>
      <p className="px-4 pb-8 text-base font-normal text-textColor">
        {`${t("are_you_sure_that_is")} `}
        <b className="text-headingTextColor" dir="ltr">
          {`${combinePhoneNumberWithISO(countryZipCode, phoneNumber)}`}
        </b>{" "}
        {`${t("your_correct_number")} `}
      </p>
      <div className="flex items-center justify-center gap-4">
        {!hideEditButton ? (
          <Button
            title={t("edit")}
            onClick={() => {
              setShow(false);
              editButtonOnClickFunction();
            }}
            variant="secondary"
            extraClassName="!text-primaryMain"
          />
        ) : (
          false
        )}
        <Button
          title={disableButtonCondition ? t("loading") : t("continue")}
          variant="primary"
          onClick={() => navigateAfterSuccessFunction()}
          disabled={disableButtonCondition}
        />
      </div>
      {error ? <ErrorsWrapper message={error?.message} /> : null}
    </Modal>
  );
};

export default VerifiyNumberPopup;
